module.exports = __webpack_public_path__ + "static/media/home_active.98e74f8c.svg";